(() => {
  const currentHost = window.location.hostname;
  if (!currentHost) return;

  const oldHosts = [
    'www.scifiplanet.co.uk',
    'scifiplanet.co.uk',
    'www.shopscottish.com',
    'shopscottish.com',
    'new.scifiplanet.co.uk',
    'new.shopscottish.com',
    'scifidev.wrightwaydemo.co.uk',
    'scotdev.wrightwaydemo.co.uk',
  ];
  const storeAddressHtml = '127 George Street<br>Oban<br>Argyll<br>PA34 5NT<br>United Kingdom';
  const storeAddressText = '127 George Street, Oban, Argyll, PA34 5NT, United Kingdom';
  const addressPlaceholderSearchPattern = /\[(?:INSERT\s+)?(?:RETURN\s+)?ADDRESS\]/i;
  const addressPlaceholderReplacePattern = /\[(?:INSERT\s+)?(?:RETURN\s+)?ADDRESS\]/gi;
  const isShopScottish = /(?:^|\.)shopscottish\.com$|scotdev\.wrightwaydemo\.co\.uk/i.test(currentHost);
  const contactEmail = isShopScottish ? 'sales@shopscottish.com' : 'sales@scifiplanet.co.uk';
  const contactEmailHtml = `<a href="mailto:${contactEmail}">${contactEmail}</a>`;
  const emailPlaceholderSearchPattern = /\[(?:\.|@|•|●|&bull;|&#8226;|&#x2022;|email|e-mail|mail)\]/i;
  const emailPlaceholderReplacePattern = /\[(?:\.|@|•|●|&bull;|&#8226;|&#x2022;|email|e-mail|mail)\]/gi;

  function rewriteUrl(value) {
    if (!value) return value;
    if (/^(mailto|tel|sms):/i.test(value)) return value;

    let next = value;
    oldHosts.forEach((host) => {
      next = next.replaceAll(`https://${host}`, window.location.origin);
      next = next.replaceAll(`http://${host}`, window.location.origin);
      next = next.replaceAll(host, currentHost);
    });

    next = next.replace(/\/us\//g, '/');
    next = next.replace(/\/customer\/account\/?$/g, '/account');
    next = next.replace(/\bwww\.www\./gi, 'www.');
    return next;
  }

  function rewriteTextNode(node) {
    let next = node.nodeValue;

    if (!/@(?:www\.)?(?:scifiplanet\.co\.uk|shopscottish\.com)\b/i.test(next)) {
      oldHosts.forEach((host) => {
        next = next.replaceAll(host, currentHost);
      });
      next = next.replace(/\bwww\.www\./gi, 'www.');
    }

    next = next.replace(addressPlaceholderReplacePattern, storeAddressText);
    next = next.replace(emailPlaceholderReplacePattern, contactEmail);
    if (next !== node.nodeValue) node.nodeValue = next;
  }

  function walkText(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        if (
          !node.nodeValue ||
          (
            !oldHosts.some((host) => node.nodeValue.includes(host)) &&
            !addressPlaceholderSearchPattern.test(node.nodeValue) &&
            !emailPlaceholderSearchPattern.test(node.nodeValue)
          )
        ) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(rewriteTextNode);
  }

  function normalizeContentPlaceholders(root) {
    root.querySelectorAll('.rte, .shopify-policy__body, main').forEach((container) => {
      container.querySelectorAll('p, strong, b, span, li').forEach((element) => {
        const text = element.textContent || '';
        const html = element.innerHTML;
        if (!addressPlaceholderSearchPattern.test(text) && !emailPlaceholderSearchPattern.test(text) && !emailPlaceholderSearchPattern.test(html)) return;

        const nextHtml = html
          .replace(addressPlaceholderReplacePattern, storeAddressHtml)
          .replace(emailPlaceholderReplacePattern, contactEmailHtml);

        if (nextHtml !== html) element.innerHTML = nextHtml;
      });
    });
  }

  function normalize() {
    document.querySelectorAll('a[href]').forEach((link) => {
      if (link.dataset.domainKeepUrl === 'true') return;
      const next = rewriteUrl(link.getAttribute('href'));
      if (next && next !== link.getAttribute('href')) link.setAttribute('href', next);
    });

    document.querySelectorAll('form[action]').forEach((form) => {
      const next = rewriteUrl(form.getAttribute('action'));
      if (next && next !== form.getAttribute('action')) form.setAttribute('action', next);
    });

    normalizeContentPlaceholders(document.body);
    walkText(document.body);
  }

  document.addEventListener('DOMContentLoaded', normalize);
  document.addEventListener('shopify:section:load', normalize);
})();
